export const FAULTY_EVENT_HAZARD_CATEGORIES = ['Wild Fires'];
